import React, { Component, createElement } from 'react'
import autoBind from 'react-auto-bind'
import PropTypes from 'prop-types'

import Visibility from './visibility'

class SharePopup extends Component {
  constructor (props) {
    super(props)
    autoBind(this)
  }

  copyClicked (e) {
    const t = e.currentTarget
    const c = t.dataset.copytarget
    const inp = (c ? document.querySelector(c) : null)

    if (inp && inp.select) {
      inp.select()
      try {
        document.execCommand('copy')
        inp.blur()
      } catch (err) {
        alert('Please copy manually')
      }
    }
    this.props.sharedBy('copy')
  }

  whatsappClicked (e) {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    let link = ''
    if (/android/i.test(userAgent)) {
      link = 'https://play.google.com/store/apps/details?id=com.whatsapp'
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      link = 'https://itunes.apple.com/app/id310633997'
    }
    const delay = 1000
    const start = new Date().getTime()
    setTimeout(() => {
      var end = new Date().getTime()
      if ((this.visibility && this.visibility.isHidden()) || (end - start >= delay * 2)) return
      window.open(link, '_blank')
    }, delay)
    this.props.sharedBy('whatsapp')
  }

  fbClicked () {
    this.props.sharedBy('fb')
  }

  twitterClicked () {
    this.props.sharedBy('twitter')
  }

  gmailClicked () {
    this.props.sharedBy('gmail')
  }

  render () {
    const { text, url, shareModalOpen } = this.props;

    return (
      <div className='share-popup'>
        {shareModalOpen && <Visibility ref={(node) => { this.visibility = node }} />}
        <a className='sp-tab' href={`https://api.whatsapp.com/send?text=${encodeURIComponent(text) + ' ' + encodeURIComponent(url)}`} onClick={this.whatsappClicked} target='_blank'>
          <div className='icon whatsapp' />
          <span className='text'>WhatsApp</span>
        </a>
        <a className='sp-tab' href={`http://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}&p[title]=${encodeURIComponent(text)}`} onClick={this.fbClicked} target='_blank'>
          <div className='icon fb' />
          <span className='text'>Facebook</span>
        </a>
        <a className='sp-tab' href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`} onClick={this.twitterClicked} target='_blank'>
          <div className='icon twitter' />
          <span className='text'>Twitter</span>
        </a>
        <a className='sp-tab' href={`https://mail.google.com/mail/u/0/?view=cm&ui=2&tf=0&fs=1&su=${text}&body=Check out this awesome link... %0A${url}`} onClick={this.gmailClicked} target='_blank'>
          <div className='icon gmail' />
          <span className='text'>Mail</span>
        </a>
        <div className='sp-tab copy' onClick={this.copyClicked} data-copytarget='#url'>
          <div className='copy-input'>
            <input type='text' id='url' value={url} readOnly />
          </div>
          <div>
            <div className='icon copy' />
            <span className='text'>Copy to clipboard</span>
          </div>
        </div>
      </div>
    )
  }
}

export default class ShareBtn extends Component {
  constructor (props) {
    super(props)
    this.state = {
      shareModalOpen: false
    }
    this.toggleShare = this.toggleShare.bind(this)
  }

  toggleShare () {
    const { onShareBtnClick, url, text, title = text } = this.props;
    const { shareModalOpen } = this.state;

    if (!shareModalOpen && onShareBtnClick) {
      onShareBtnClick()
    }
    if (navigator && navigator.share !== undefined) {
      navigator.share({
        title,
        text,
        url
      }).then(() => console.log('Successful share'))
      .catch(error => console.log('Error sharing:', error))
    } else {
      document.body.style.overflow = !shareModalOpen ? 'hidden' : 'auto'
      this.setState(state => ({shareModalOpen: !state.shareModalOpen}))
    }
  }

  render () {
    const { tag = "div", buttonProps, onShareBtnClick, className, children, displayText, ...otherProps } = this.props;
    return (
      <div className={`share-btn ${className}`}>
        {createElement(tag, {
          ...buttonProps,
          onClick: this.toggleShare
        }, children, displayText)}
        <div className={`share-modal ${this.state.shareModalOpen ? 'open' : ''}`}>
          <div className='overlay' onClick={this.toggleShare} />
          <SharePopup {...otherProps} toggleShare={this.toggleShare} shareModalOpen={this.state.shareModalOpen} />
        </div>
      </div>
    )
  }
}

ShareBtn.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  displayText: PropTypes.string,
  onShareBtnClick: PropTypes.func
}

ShareBtn.defaultProps = {
  url: '',
  text: '',
  className: '',
  displayText: 'Share',
  onShareBtnClick: () => {},
  sharedBy: (medium) => {
    console.log('Shared via ', medium)
  }
}

SharePopup.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
  shareModalOpen: PropTypes.bool,
  toggleShare: PropTypes.func,
  sharedBy: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/ShareButton/ShareBtn.js